import ClubPromoController from '@club/customer/api/ClubPromoController'
import Table from '@components/modules/Table'
import useAuth from '@hooks/useAuth'
import useRequestEffect from '@hooks/useRequestEffect'
import React from 'react'
import columns from './config/columns'
import options from './config/options'

export default function MemberDiscountsTable() {
    const auth = useAuth<Resources.ClubMember>()
    const [promos, setPromos] = useRequestEffect(() => ClubPromoController.index(auth.user.membership.club.id)) 
    return <Table data={promos} columns={columns} options={options} />
}